import React from 'react'
import { InputContainer } from '../../../../../common/components/form/form.module'

export default function ModalTemplateComponent({ Close
    , visibility, deliverymode, handleItemSubmit, selectedTemplate, templates, onInnerBasicFormChange, TemplateGroupEntityType }: any) {
    return (

        <div className="  w-full p-2 bg-white shadow-md rounded-md">
            <h1 className="text-xl font-bold mb-4 text-center">Add Template Groups</h1>
            <div className=" grid md:grid-cols-2 lg:grid-cols-2 gap-4 border p-4">


                <InputContainer
                    label="Name"
                    name="Name"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'Name',

                        )
                    }}
                    type="text"
                    value={selectedTemplate?.Name}
                />


                <InputContainer
                    label="Entity Type"
                    labelField="Description"
                    list={TemplateGroupEntityType.filter(item => item.Value !== 13)}
                    onValueChange={(event: any, newValue: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'TemplateGroupEntityType',
                        );
                    }}
                    optionName='Choose Entity Type'
                    type="select"
                    value={selectedTemplate?.TemplateGroupEntityType}
                    valueField="Value"
                />

                {selectedTemplate?.TemplateGroupEntityType === 10 && (
                    
                        <InputContainer
                            label="Marketing Template"
                            labelField="Name"
                            list={templates}
                            onValueChange={(event: any, newValue: any) => {
                                onInnerBasicFormChange(
                                    event.target.value,
                                    'EntityId',
                                );
                            }}
                            optionName='Choose Entity Type'
                            type="select"
                            value={selectedTemplate?.EntityId}
                            valueField="Id"
                        />
                   
                )}




                <InputContainer
                    label="Start Date"
                    name="StartDateUtc"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'StartDateUtc'
                        )
                    }}
                    type="date"
                    value={selectedTemplate?.StartDateUtc}
                />

                <InputContainer
                    label="End Date"
                    name="EndDateUtc"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'EndDateUtc'
                        )
                    }}
                    type="date"
                    value={selectedTemplate?.EndDateUtc}
                />

                <InputContainer

                    label="Active"
                    name="IsActive"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event,
                            'IsActive'
                        )
                    }}
                    type="checkbox"
                    value={selectedTemplate?.IsActive}
                />


            </div>


            <div className="flex justify-end mt-6">
                <button
                    onClick={Close}
                    type="button"
                    className="m-2 bg-blue-900 text-white rounded font-medium px-4 py-3"
                >
                    Close
                </button>
                <button
                    className="m-2 bg-blue-900 text-white rounded font-medium px-4 py-3"
                    onClick={handleItemSubmit}
                    type="submit"
                >
                    Save
                </button>
            </div>

        </div>



    )
}